import { useRouter } from 'next/router'

export const useIsEmbedding = () => {
  const router = useRouter()

  return router.pathname === '/map/[mapId]/embed'
}
